// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_arMhfd","inline":"ob_bfTaUV","label":"ob_QpgYt7","features":"ob_PewPhb","price":"ob_BarDwu","list":"ob_Mkvp6O","priceWrapper":"ob_nZc7ym"};